import React from "react";

// SVG logo, evoking the Kidzkulam pencil-and-tree aesthetic.
export function KidzkulamLogo({ size = 42, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        {/* trunk */}
        <path d="M30 44c-1-6 1-10 2-14 1 6 3 10 2 14z" fill="#7B4F2E" />
        {/* canopy */}
        <circle cx="32" cy="22" r="18" fill="hsl(142 52% 43%)" />
        <circle cx="22" cy="16" r="10" fill="hsl(142 60% 55%)" />
        <circle cx="44" cy="20" r="9" fill="hsl(142 60% 55%)" />
        <circle cx="34" cy="10" r="6" fill="hsl(75 65% 55%)" />
        {/* pencils */}
        <rect x="8" y="46" width="6" height="14" rx="1" fill="hsl(340 82% 65%)" />
        <path d="M8 46l3-4 3 4z" fill="#3a2a2a" />
        <rect x="50" y="46" width="6" height="14" rx="1" fill="hsl(187 71% 55%)" />
        <path d="M50 46l3-4 3 4z" fill="#3a2a2a" />
      </svg>
      <div className="leading-none">
        <div className="font-black text-lg tracking-tight" style={{ color: "hsl(142 52% 33%)" }}>
          Kidzkulam
        </div>
        <div className="text-[10px] font-semibold tracking-[0.15em] uppercase text-muted-foreground">
          Play School
        </div>
      </div>
    </div>
  );
}
